import { render, staticRenderFns } from "./PartnersChart.vue?vue&type=template&id=78788a54&"
import script from "./PartnersChart.vue?vue&type=script&lang=js&"
export * from "./PartnersChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports